exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".simulation-controls_sim-button_2pqwy {\n    background: none;\n    border: none;\n    outline: none;\n    padding: 6px;\n    cursor: pointer;\n    display: block;\n}\n", ""]);

// exports
exports.locals = {
	"sim-button": "simulation-controls_sim-button_2pqwy",
	"simButton": "simulation-controls_sim-button_2pqwy"
};